import { gql } from "@apollo/client";
export const WORKSHEET_FIELDS = gql`
  fragment WorksheetFields on Worksheet {
    name
    scope
    scopeFormat
    quantity
    unit
    rate
    pricingMethod
    pricingOverrideField
    markup
    overheadPercentage
    indirectPercentage
    fixedPrice
    profitAmount
    pricingBaseline {
      pricingMethod
      markup
      fixedPrice
      profitAmount
    }
    areaSource
    area
    areaUnit
    rows {
      sourcePlantId
      sourcePlantName
      sourceType
      sourceId
      sourceName
      name
      category
      jobSize
      jobSizeUnit
      hoursPerTruck
      truckingUnit
      trucksNeeded
      truckCapacity
      truckRateHours
      truckRateTons
      truckRateYards
      truckRateLoads

      quantity
      unit
      rate
      calculation
      factor
      factorAreaUnit
      factorLabel
      thickness
      quantityOverride
    }
  }
`;
export const SETTINGS = gql`
  query WorksheetSettings {
    worksheetSettings {
      enabled
      method
      markup
      canManageProducts
      canManageSettings
      factors {
        label
        value
      }
    }
  }
`;
export const PRODUCTS = gql`
  query WorksheetProducts {
    worksheetProducts {
      organizationProductType {
        id
        name
      }
      id
      definition {
        ...WorksheetFields
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
export const PROPOSAL = gql`
  query WorksheetProposal($id: ID!) {
    worksheetProposal(id: $id) {
      id
      estimatingMethod
      stages {
        id
        proposalProducts {
          id
          ordering
          isOptional
          discount
          overallTotalAfterDiscount
          worksheet {
            ...WorksheetFields
          }
        }
      }
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
        }
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
export const SAVE_PRODUCT = gql`
  mutation SaveWorksheetProduct($id: ID, $productTypeId: ID!, $input: WorksheetInput!) {
    saveWorksheetProduct(id: $id, productTypeId: $productTypeId, input: $input) {
      id
      organizationProductType {
        id
        name
      }
      definition {
        ...WorksheetFields
      }
    }
  }
  ${WORKSHEET_FIELDS}
`;
export const ARCHIVE_PRODUCT = gql`
  mutation ArchiveWorksheetProduct($id: ID!) {
    archiveWorksheetProduct(id: $id)
  }
`;
export const SAVE_ITEM = gql`
  mutation SaveWorksheetItem($id: ID, $stageId: ID!, $input: WorksheetInput!, $discount: String) {
    saveWorksheetItem(id: $id, stageId: $stageId, input: $input, discount: $discount) {
      id
    }
  }
`;
export const SWITCH = gql`
  mutation SetProposalEstimatingMethod($id: ID!, $method: String!) {
    setProposalEstimatingMethod(id: $id, method: $method) {
      id
      estimatingMethod
    }
  }
`;
export const SAVE_SETTINGS = gql`
  mutation UpdateWorksheetSettings($method: String!, $markup: String!) {
    updateWorksheetSettings(method: $method, markup: $markup) {
      enabled
      method
      markup
      canManageProducts
      canManageSettings
      factors {
        label
        value
      }
    }
  }
`;

export const PRODUCT_TYPES = gql`
  query WorksheetProductTypes {
    getOrganizationProductTypes {
      id
      name
    }
  }
`;
